import React, { Component } from 'react';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { GeoJSON } from 'react-leaflet';
import {openCountrySongsModal} from '../../state-management/actions/modal-actions';
import {
	getCountrySongsRequest,
	setSelectedCountry
} from '../../state-management/actions/songs-actions';
import{
	showCountryNameTooltip
}  from '../../state-management/actions/map-actions';


class WorldGeoJSON extends Component {	

	getColor = (countryNameInitial) =>{
		const colorArr = [
			'#FA8072', '#FFD700', '#4682B4', '#DC143C','#8B008B', 
			'#FFC0CB', '#696969', '#DAA520', '#FF8C00', '#808000', 
			'#FF7F50', '#FF0000', '#6B8E23','#7FFF00','#0000FF',
			'#008B8B', '#6A5ACD', '#F0E68C', '#1E90FF','#FFFF00', 
			'#C71585', '#5F9EA0', '#FFFFF0', '#32CD32', '#f5c9d7', 
			'#FF8C00'];
		return colorArr[countryNameInitial];
	}
	
	style = (feature) => {
		const {
			countriesSongsMap,
			countriesWithSongs,
			highlightedCountry
		} = this.props;
		// console.log('c s m', countriesSongsMap);
		const countryName = feature.additionalData.name;
		const countryNameInitial = feature.additionalData.name.charCodeAt(0) - 65;
		const countryHasSongs = _.has(countriesSongsMap, countryName);
		const fillOpacity = countryHasSongs || highlightedCountry === countryName ? 1.0 : 0.06;
		
		const fillColor = highlightedCountry === countryName ? 'white' : this.getColor(countryNameInitial);
		const color = highlightedCountry === countryName ? 'red' : 'transparent';

		return {
			fillColor,
			weight: 0.5,
			color,
			fillOpacity
		};
	}
	
	
	clickFeature =(e) =>{
		const {
			getCountrySongsRequest,
			history, 
			openCountrySongsModal, 
			setSelectedCountry
			} = this.props;
		let layer = e.target;	
		let selectedCountryName = layer.feature.additionalData.name;
		// console.log('sel country', selectedCountryName);
		if (selectedCountryName === 'Antarctica'){
			return;
		}
		const selectedCountry = {
			countrySelected: selectedCountryName
		}
		getCountrySongsRequest(selectedCountry);
		setSelectedCountry(selectedCountryName);		
		// openCountrySongsModal();
	}
	
	resetHighlight = (e) => {
		const{
			showCountryNameTooltip
		} = this.props;
		// showCountryNameTooltip('');
		const layer = e.target;
		if (layer.options.color === '#c1442e') {
			layer.setStyle({
				weight: 5,
				color: '',
				dashArray: '',
				fillOpacity: 0.7
			});
		}
	
	}

	mouseOver = (e) => {
		const{
			showCountryNameTooltip
		} = this.props;
		let layer = e.target;	
		let selectedCountryName = layer.feature.additionalData.name;

		showCountryNameTooltip(selectedCountryName);
	}
	onEachFeature = (feature, event) =>{				
		event.on({
			mouseout: this.resetHighlight,
			click: this.clickFeature,
			mouseover:this.mouseOver
		});
	}
	

	render(){
		const {worldData} = this.props;
		
		return (
			<GeoJSON
				data={worldData}
				style={this.style}
				onEachFeature={this.onEachFeature.bind(this)}
				ref="geojson"
			/>
		);
	}
}

const mapStateToProps = state => {
	const {mapReducers, songsReducers} = state;
	const {
		countriesSongsMap,
		countriesWithSongs
	} = songsReducers;

	return {
		countriesSongsMap,
		countriesWithSongs,
		highlightedCountry: mapReducers.highlightedCountry
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getCountrySongsRequest:(selectedCountrySongs)=> dispatch(getCountrySongsRequest(selectedCountrySongs)),
		openCountrySongsModal: () => dispatch(openCountrySongsModal()),
		setSelectedCountry: (selectedCountryName) => dispatch(setSelectedCountry(selectedCountryName)),
		showCountryNameTooltip:(countryName) => dispatch(showCountryNameTooltip(countryName))
	};
  }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorldGeoJSON));